const runRequestPermission = (feature, callback, self) => {
        
    console.log('runRequest permission called', feature)

    if(window.cordova){
        console.log('inside window.cordova', feature)
        let permissions = []
        let status

        if(feature == 'LOCATION'){
            if(process.env.REACT_APP_BACKGROUND_LOCATION_PERMISSION_ENABLED == "true"){
                permissions.push(window.cordova.plugins.diagnostic.permission.ACCESS_FINE_LOCATION,
                           window.cordova.plugins.diagnostic.permission.ACCESS_COARSE_LOCATION,
                           window.cordova.plugins.diagnostic.permission.ACCESS_BACKGROUND_LOCATION)
            } else {
                permissions.push(window.cordova.plugins.diagnostic.permission.ACCESS_FINE_LOCATION,
                    window.cordova.plugins.diagnostic.permission.ACCESS_COARSE_LOCATION)
            }
        } else if(feature == 'CAMERA'){
            console.log('inside condition for camera', feature)
            permissions.push(window.cordova.plugins.diagnostic.permission.CAMERA)
        } else if(feature == 'BLUETOOTH'){
            console.log('inside condition for bluetooth', feature)
            permissions.push(window.cordova.plugins.diagnostic.permission.BLUETOOTH_SCAN,
                             window.cordova.plugins.diagnostic.permission.BLUETOOTH_ADVERTISE,
                             window.cordova.plugins.diagnostic.permission.BLUETOOTH_CONNECT)
        }else if(feature == 'NOTIFICATION'){
                console.log("[Notification] inside running notification permission foe android for AA flow");
                permissions.push(window.cordova.plugins.diagnostic.permission.POST_NOTIFICATIONS)
        }

        window.cordova.plugins.diagnostic.requestRuntimePermissions(function(statuses){
            console.log('permission callback');
            for (var permission in statuses){
                switch(statuses[permission]){
                    case window.cordova.plugins.diagnostic.permissionStatus.GRANTED:
                        console.log("Permission granted to use "+permission);
                        status = true //callback(true, self);
                        break;
                    case window.cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
                        console.log("NOT_REQUESTED")
                        console.log("Permission to use "+permission+" has not been requested yet");
                        status = false //callback(false, self);
                        break;
                    case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ONCE:
                        console.log("DENIED_ONCE")
                        console.log("Permission denied to use "+permission+" - ask again?");
                        status = false //callback(false, self);
                        break;
                    case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                        console.log("DENIED_ALWAYS")
                        console.log("Permission permanently denied to use "+permission+" - guess we won't be using it then!");
                        status = false //callback(false, self);
                        break;
                    default:
                        console.log("request Runtime Permissions default statement.")
                        callback();
                }
            }
            callback(status, self);

        }, function(error){
            console.error("The following error occurred: "+error);
        },permissions);
    }
}

export default runRequestPermission;